import Link from 'next/link';
import { getContentImageProps, resolveImageAltText } from '@/lib/utils';

export default function ImageBackgroundCta({ block, position }) {
  const {
    mobile_background_image,
    desktop_background_image,
    text,
    button_text,
    text_color,
    link,
    button_color,
    button_hover_color,
    _metadata
  } = block.image_background_cta;

  const mobileImage = mobile_background_image;
  const desktopImage = desktop_background_image;

  const { srcSet: desktopSrcSet } = getContentImageProps({
    image: desktopImage
  });
  const { srcSet: mobileSrcSet, remainingProps } = getContentImageProps({
    image: mobileImage
  });

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name={'banner-image-background-cta'}
      className="relative"
    >
      <picture>
        <source media="(min-width: 640px)" srcSet={desktopSrcSet} />
        <source srcSet={mobileSrcSet} />
        <img
          {...remainingProps}
          className="bg-parlor-green block h-[298px] w-full object-cover sm:h-[238px] lg:h-[248px]"
          alt={resolveImageAltText(desktopImage)}
        />
      </picture>
      <div className="absolute inset-0 my-auto flex h-full justify-center">
        <div className="self-center">
          <div
            className={`h5 lg:h3 mb-10 flex justify-center px-[60px] text-center sm:px-0 text-[${text_color}]`}
          >
            {text}
          </div>
          <div className="flex justify-center">
            <Link
              href={link}
              prefetch={false}
              title={button_text}
              className={`btn text-white bg-[${button_color}] hover:bg-[${button_hover_color}]`}
            >
              {button_text}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
